/* src/app/components/terminals/terminals.component.scss */
/*# sourceMappingURL=terminals.component-CZ6KEURB.css.map */
